import { ReactElement } from "react";

import clsx from "clsx";
import { Button } from "react-bulma-components";
import styled from "styled-components";

const Message = styled.p`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

interface ConfirmDialogProps {
  message: string;
  isOpen: boolean;
  closeDialog: () => void;
  confirmedAction: () => void;
}

export function ConfirmDialog({
  message,
  isOpen,
  closeDialog,
  confirmedAction,
}: ConfirmDialogProps): ReactElement | null {
  const onClickConfirm = () => {
    confirmedAction();
    closeDialog();
  };

  return (
    <div className={clsx("modal", "cw-confirm-dialog", isOpen && "is-active")}>
      <div className="modal-background" />
      <div className="modal-card">
        <section className="modal-card-body">
          <Message>{message}</Message>
        </section>
        <footer className="modal-card-foot">
          <Button onClick={() => closeDialog()}>いいえ</Button>
          <Button color="primary" onClick={() => onClickConfirm()}>
            はい
          </Button>
        </footer>
      </div>
    </div>
  );
}
